export enum AngaraKeys {
    VacancyName = 'vacancyName',
    VacancyUrl = 'vacancyUrl',
    Prefilter = 'prefilter',
    LinearFilter = 'linearFilter',
    TreeFilter = 'treeFilter',
    TreeRanker = 'treeRanker',
    TimeBoosted = 'timeBoosted',
    Reranker = 'reranker',
}

export const TRLS_HEADERS_FOR_ANGARA = {
    [AngaraKeys.VacancyName]: 'vacancy name',
    [AngaraKeys.VacancyUrl]: 'vacancy url',
    [AngaraKeys.Prefilter]: 'prefilter score',
    [AngaraKeys.LinearFilter]: 'linear filter score',
    [AngaraKeys.TreeFilter]: 'tree filter score',
    [AngaraKeys.TreeRanker]: 'tree ranker score',
    [AngaraKeys.TimeBoosted]: 'time boosted score',
    [AngaraKeys.Reranker]: 'reranker score',
};

export const COLUMN_FOR_ANGARA = [
    AngaraKeys.VacancyName,
    AngaraKeys.VacancyUrl,
    AngaraKeys.Prefilter,
    AngaraKeys.LinearFilter,
    AngaraKeys.TreeFilter,
    AngaraKeys.TreeRanker,
    AngaraKeys.TimeBoosted,
    AngaraKeys.Reranker,
];

export type AngaraExplanation = {
    [key in AngaraKeys]: string;
}[];

export const downloadCSV = (fileName: string, csv: string): void => {
    const code = 'data:text/csv;charset=utf-8,';
    const encodedCsv = encodeURI(code + csv);
    const link = document.createElement('a');
    link.setAttribute('href', encodedCsv);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const generateAngaraCSV = (data: AngaraExplanation): string => {
    const headersCSV = `${COLUMN_FOR_ANGARA.map((column) => TRLS_HEADERS_FOR_ANGARA[column]).join(',')}\n`;
    const dataCSV = data
        .map((row) =>
            COLUMN_FOR_ANGARA.map((column) => {
                // escaping vacancy title
                if (column === AngaraKeys.VacancyName) {
                    return `"${row[column]}"`;
                }
                return row[column];
            }).join(',')
        )
        .join('\n');
    return headersCSV + dataCSV;
};
